import './css/Home.css'

import {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';

import NavBar from '../components/NavBar'
import LandingBackground from '../components/LandingBackground'

import arrow from '../assets/images/tool_arrow.png'

const Home = () => {
    const navigate = useNavigate(); // ✅ Hook at top level

    const handleClick = () => {
        navigate('/app'); // ✅ Call the function inside event handler
    };
    useEffect(()=>{
    },[])

    return (
        <section className = 'Home'>
            <NavBar/>

            <div className="content">
                <LandingBackground />
                
                <div className="landing-info">
                    <h1>Paint Your Github Green</h1>
                    <p>Make every square count. Transform your contribution graph with real commits based on your custom designs  past or present.</p>
                    <button onClick = {handleClick}>try it out now <img src={arrow} alt="" /></button>
                </div>

            </div>
        </section>
    )
}

export default Home